<template>
    <ul class="button-group">
        <li
            v-for="option in options"
            :key="option.value"
            class="button-group__item"
            :class="getStateClass(option)"
        >
            <button
                class="button-group__button"
                type="button"
                @click="onClick(option.value)"
            >
                {{ option.text }}
            </button>
        </li>
    </ul>
</template>

<script>
import { STATE_CLASSES } from '@/data/constants/classes';

export default {
    name: 'button-group',

    props: {
        options: {
            type: Array,
            default: () => [
                { text: 'Option 1', value: 1 },
                { text: 'Option 2', value: 2 },
                { text: 'Option 3', value: 3 },
            ],
        },

        value: {
            type: String,
            default: '',
        },
    },

    data() {
        return {
            internalValue: this.value,
        };
    },

    watch: {
        value(newVal) {
            this.internalValue = newVal;
        },
    },

    methods: {
        getStateClass(option) {
            return { [STATE_CLASSES.SELECTED]: option.value === this.internalValue };
        },

        onClick(newValue) {
            this.internalValue = this.internalValue !== newValue ? newValue : '';
            this.$emit('input', this.internalValue);
        },
    },
};
</script>

<style lang="scss">
.button-group {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    padding: 0;
    margin: 0;
    border: 1px solid var(--form-inputBorderColor);
    border-radius: 5px;
    overflow: hidden;

    &__item {
        color: var(--app-color);
        background-color: transparent;
        flex-grow: 1;
        list-style: none;
        font-weight: 400;
        width: 33.3334%;

        &.#{ $is-selected } {
            color: var(--form-buttonHoverColor);
            background-color: var(--form-buttonHoverBackgroundColor);
            background-image: none;
            font-weight: 700;
            border-color: var(--form-buttonHoverBorderColor);
        }

        &:nth-of-type(3n+2),
        &:nth-of-type(3n+3) {
            border-left: 1px solid var(--form-inputBorderColor);
        }

        &:nth-of-type(n+4) {
            border-top: 1px solid var(--form-inputBorderColor);
        }
    }

    &__button {
        width: 100%;
        color: inherit;
        font-weight: inherit;
        padding: 5px 10px;
        font-size: 13px;
    }
}
</style>
